import React from 'react';
import { format } from 'date-fns';

export default class Reports extends React.Component {
	constructor(props) {
		super(props);
	}

    onPrintReport(rpt) {
		if (rpt.file) {
			print.pdf('/reports/generate.json', $.param({report_id: rpt.id}))
		}
		else {
			print.pdf('/pdfs/generate.json', $.param({report_id: rpt.id, id: rpt.alias}))
		}
	}

	render() {
		if (!this.props.reports) {
			return null;
		}
		const reports = this.props.reports;

		return (
			<div className="dropdown btn-group">
				<button
					className="btn btn-default dropdown-toggle"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="true"
				>
					<em className="la la-print" />
					<span>{__('buttons_reports')}</span>
					<span className="caret" />
				</button>
				<ul className="dropdown-menu dropdown-menu-right">
					{reports.map((report, index) => (
						<li key={index}>
							<a onClick={this.onPrintReport.bind(this, report)}>
								<em className={`la la-${report.file ? 'file-text-o' : 'file-pdf-o'}`}/>
								<span>{report.name}</span>
							</a>
						</li>
					))}
				</ul>
			</div>
		);
	}
}
